var map = {
	"./decidim/avatar-multiuser.png": 16994,
	"./decidim/brands/google.svg": 66669,
	"./decidim/cc-badge.png": 62748,
	"./decidim/decidim-logo.svg": 95056,
	"./decidim/default-avatar.svg": 75144,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 38996,
	"./decidim/icons.svg": 65667,
	"./decidim/pattern.png": 38260,
	"./decidim/placeholder-card-g.svg": 90849,
	"./decidim/placeholder-card-l.svg": 40970,
	"./decidim/placeholder.jpg": 50233,
	"./decidim/remixicon.symbol.svg": 8173,
	"./decidim/vendor/leaflet/layers-2x.png": 47180,
	"./decidim/vendor/leaflet/layers.png": 26267,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 92982,
	"./decidim/vendor/leaflet/marker-icon.png": 75085,
	"./decidim/vendor/leaflet/marker-shadow.png": 72866,
	"./decidim/vendor/social-share-button/douban.svg": 61436,
	"./decidim/vendor/social-share-button/email.svg": 65945,
	"./decidim/vendor/social-share-button/facebook.svg": 49071,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 90257,
	"./decidim/vendor/social-share-button/hacker_news.svg": 74841,
	"./decidim/vendor/social-share-button/linkedin.svg": 91673,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 69530,
	"./decidim/vendor/social-share-button/pinterest.svg": 78207,
	"./decidim/vendor/social-share-button/reddit.svg": 22435,
	"./decidim/vendor/social-share-button/telegram.svg": 30614,
	"./decidim/vendor/social-share-button/tumblr.svg": 69717,
	"./decidim/vendor/social-share-button/twitter.svg": 11048,
	"./decidim/vendor/social-share-button/vkontakte.svg": 44870,
	"./decidim/vendor/social-share-button/wechat.svg": 81537,
	"./decidim/vendor/social-share-button/whatsapp.svg": 51785,
	"./decidim/vendor/social-share-button/x.svg": 57665,
	"./decidim/vendor/social-share-button/xing.svg": 97679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78833;